<div class="offline-container">
  <div class="offline-logo">
  </div>
  <div class="offline-body">
    <div class="icon alert">
      <em>Attention!</em>
      <span></span>
    </div>
    <h1 id="site-unavailable" class="no-mobile">Site Unavailable</h1>
    <h1 id="maintenance" class="mobile">Maintenance</h1>
    <p>
      We are conducting routine maintenance and will be back online as soon as maintenance is complete. We apologize
      for any inconvenience this may cause. </p>
    <p>If this is during normal business hours, please contact our Customer Service department at {{footerData.InquiryNumber}}. Thank
      you for your patience.</p>
  </div>
  <div id="offline-footer" class="offline-footer">
  {{footerData.Copyright}}
  </div>
</div>